function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M122 123C189.379 123 244 115.613 244 106.5V88.5C244 97.6127 189.379 105 122 105C54.6213 105 0 97.6127 0 88.5V106.5C0 115.613 54.6213 123 122 123Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122 123C189.379 123 244 115.613 244 106.5V88.5H122H0V106.5C0 115.613 54.6213 123 122 123Z",
  fill: "url(#paint0_linear3)",
  fillOpacity: 0.25
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 88.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 88.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint1_linear3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122 105C189.379 105 244 97.6127 244 88.5C244 88.5 244 87.5 243.5 87.5C238.5 92 224.144 95.1874 192 98C155 101.237 113.5 101.864 72.5 100C59.3234 99.401 6.5 95.5 0.500003 87C0 88 0 88.5 0 88.5C0 97.6127 54.6213 105 122 105Z",
  fill: "url(#paint2_linear3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128 101C195.379 101 250 93.6126 250 84.4999V66.5C250 75.6127 195.379 83 128 83C60.6213 83 6 75.6127 6 66.5V84.4999C6 93.6126 60.6213 101 128 101Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128 101C195.379 101 250 93.6126 250 84.4999V66.5H128H6V84.4999C6 93.6126 60.6213 101 128 101Z",
  fill: "url(#paint3_linear3)",
  fillOpacity: 0.25
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 128,
  cy: 66.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 128,
  cy: 66.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint4_linear3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128 83C195.379 83 250 75.6127 250 66.5C250 66.5 250 65.5 249.5 65.5C244.5 70 230.144 73.1874 198 76C161 79.2375 119.5 79.8636 78.5 78C65.3234 77.401 12.5 73.5 6.5 65C6 66 6 66.5 6 66.5C6 75.6127 60.6213 83 128 83Z",
  fill: "url(#paint5_linear3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124 77.9999C191.379 77.9999 246 70.6126 246 61.4999V43.5C246 52.6127 191.379 60 124 60C56.6213 60 2 52.6127 2 43.5V61.4999C2 70.6126 56.6213 77.9999 124 77.9999Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124 77.9999C191.379 77.9999 246 70.6126 246 61.4999V43.5H124H2V61.4999C2 70.6126 56.6213 77.9999 124 77.9999Z",
  fill: "url(#paint6_linear3)",
  fillOpacity: 0.25
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 124,
  cy: 43.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 124,
  cy: 43.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint7_linear3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124 60C191.379 60 246 52.6127 246 43.5C246 43.5 246 42.5 245.5 42.5C240.5 47 226.144 50.1874 194 53C157 56.2375 115.5 56.8636 74.5 55C61.3234 54.401 8.5 50.5 2.5 42C2 43 2 43.5 2 43.5C2 52.6127 56.6213 60 124 60Z",
  fill: "url(#paint8_linear3)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear3",
  x1: 244,
  y1: 123,
  x2: 118,
  y2: 123,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear3",
  x1: 137,
  y1: 77,
  x2: 122,
  y2: 99,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear3",
  x1: -3.63368e-8,
  y1: 105,
  x2: 244,
  y2: 105,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear3",
  x1: 250,
  y1: 101,
  x2: 124,
  y2: 101,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear3",
  x1: 143,
  y1: 55,
  x2: 128,
  y2: 77,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.17
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear3",
  x1: 6,
  y1: 82.9999,
  x2: 250,
  y2: 82.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear3",
  x1: 246,
  y1: 78,
  x2: 120,
  y2: 78,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear3",
  x1: 139,
  y1: 32,
  x2: 124,
  y2: 54,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear3",
  x1: 2,
  y1: 59.9999,
  x2: 246,
  y2: 59.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 250,
  height: 127,
  fill: "white"
})));

function Svg3Chip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 127,
    viewBox: "0 0 250 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Chip);
export default __webpack_public_path__ + "static/media/3chip.f1448225.svg";
export { ForwardRef as ReactComponent };